import React from 'react';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import sectionStyles from '../../StructuredSections.module.scss';
import { ProcessedSection } from '../../sectionProcessing';

export function renderInternalLinkBlockContent(section: ProcessedSection): React.ReactNode {
    const links = section.links ?? [];
    if (!links.length) {
        return null;
    }

    return (
        <div className={sectionStyles.sectionButtons}>
            {links.map((link, index) => {
                if (!link.href) {
                    return null;
                }

                const key = `${section.id}-link-${index}`;

                if (link.openInNewTab) {
                    return (
                        <Button
                            key={key}
                            component="a"
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="contained"
                            className={sectionStyles.sectionButton}
                        >
                            {link.text}
                        </Button>
                    );
                }

                return (
                    <Button
                        key={key}
                        component={RouterLink}
                        to={link.href}
                        variant="contained"
                        className={sectionStyles.sectionButton}
                    >
                        {link.text}
                    </Button>
                );
            })}
        </div>
    );
}
